import React from 'react';
import { Route } from 'react-router'

import CarsIntellegence from './carsIntellegence'
import CarShortInformation from '../info/carShortInformation'

const IntelligenceCarsContent = () => {
  return (
    <React.Fragment>
      <Route exact path={['/cars/:id/intimerange', '/cars/:id/inmoment']} component={CarsIntellegence} />
      <Route exact path='/cars/:id' component={CarShortInformation} />
    </React.Fragment>
  )
}

export default React.memo(IntelligenceCarsContent)